.au{flex-shrink:0;}